
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public/browse",
      function () {
        return require("private-next-pages/public/browse.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public/browse"])
      });
    }
  